import { IComponentOptions } from "angular";
import { ContractMasterDetailController } from "./controller";

export const vsName = "contractMasterDetailComponent";

export const contractMasterDetailComponentOptions: IComponentOptions = {
  controller: ContractMasterDetailController,
  controllerAs: "stateController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    contract: "<",
    contractType: "<",
  },
};
